<login-background>
    <ng-container title>Create Password</ng-container>
    <clare-spinner *ngIf="(isPendingValidation$ | async) !== false; else isNotPending" text="Verifying Password Reset Code"></clare-spinner>
</login-background>

<ng-template #isNotPending>
    <ng-container *ngIf="errorMessage$ | async as errorMessage; else showForm">
        <p>{{ errorMessage }}</p>
        <p><a (click)="gotoResetPasswordPage()" routerLink="/login/forgot-password">Please initiate another reset password request.</a></p>
    </ng-container>
</ng-template>
<ng-template #showForm>
    <form [formGroup]="pwdForm" class="password-form" (submit)="changePwd(pwdForm, newPwdRequest)">
        <p>
            Please enter a password that is at least 8 characters in length and contains at least 1 Uppercase letter, 1 Lowercase letter, 1
            Number and 1 Special character.
        </p>
        <mat-form-field>
            <input name="password" matInput type="password" placeholder="New Password" formControlName="pwd" autofocus />
            <mat-error>
                <app-validation-message [touched]="fields.pwd.touched" [errors]="fields.pwd.errors"></app-validation-message>
            </mat-error>
        </mat-form-field>
        <mat-form-field>
            <input matInput name="confirm-password" type="password" placeholder="Confirm New Password" formControlName="confirmPwd" />
            <mat-error>
                <app-validation-message [touched]="fields.confirmPwd.touched" [errors]="mismatchErr$ | async"></app-validation-message>
            </mat-error>
        </mat-form-field>
        <button [disabled]="disableSubmit" mat-raised-button color="primary" type="submit">Update Password</button>
    </form>
</ng-template>
